var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.8017 36.1544V45.6245C51.8017 46.6805 50.95 47.5322 49.894 47.5322H10.2422C9.18622 47.5322 8.3346 46.6805 8.3346 45.6245V36.1544C8.3346 35.0984 9.18622 34.2468 10.2422 34.2468C11.2983 34.2468 12.1499 35.0984 12.1499 36.1544V43.7169H47.9864V36.1544C47.9864 35.0984 48.838 34.2468 49.894 34.2468C50.95 34.2468 51.8017 35.0984 51.8017 36.1544ZM43.1605 19.8486C42.4111 20.598 41.2074 20.598 40.458 19.8486L31.7373 11.1279V36.1544C31.7373 37.2104 30.8857 38.0621 29.8297 38.0621C28.7737 38.0621 27.922 37.2104 27.922 36.1544V11.1279L19.2014 19.8486C18.8266 20.2233 18.3384 20.405 17.8501 20.405C17.3618 20.405 16.8736 20.2233 16.4989 19.8486C15.7494 19.0992 15.7494 17.8955 16.4989 17.1461L28.4784 5.16654C28.8418 4.80318 29.3187 4.61014 29.8297 4.61014C30.3407 4.61014 30.8176 4.81454 31.1809 5.16654L43.1605 17.1461C43.9099 17.8955 43.9099 19.0992 43.1605 19.8486ZM60 30C60 13.433 46.567 0 30 0C13.433 0 0 13.4217 0 30C0 46.5784 13.433 60 30 60C46.567 60 60 46.567 60 30Z",
    fill: "#E3767A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload_icon.290b4062bab926a0b5838e7a632280a8.svg";
export { ForwardRef as ReactComponent };